import { useCallback } from 'react';

import { modals } from '@/modals';
import { useModals } from '@/modals/context';
import PermissionChip from '@/app/pages/LobbyPage/PermissionChip';
import { LocationPermissionState } from '@/app/hooks/useLocationPermission';
import { EVENTS, gtag } from '@/lib/gtag';

interface LocationPermissionChipProps {
  state: LocationPermissionState;
  request(): Promise<void>;
}

/**
 * The location chip of the lobby's readiness row. Location can be blocked on
 * the site level or by the OS Location Services, so a failed request opens the
 * location reset modal with both unblock paths. The state is owned by the page,
 * which needs it to tell whether the customer is ready to join.
 */
export default function LocationPermissionChip({ state, request }: LocationPermissionChipProps) {
  const { show } = useModals();

  const onRequestPermission = useCallback(() => {
    request().catch(() => {
      gtag(EVENTS.SHOW_MODAL, { location: true });
      show({ modal: modals.RESET_LOCATION_MODAL });
    });
  }, [request, show]);

  return (
    <PermissionChip
      granted={state === 'granted'}
      name="Location"
      onEnable={onRequestPermission} />
  );
}
